import * as React from 'react';

import FilterNestedItem from '../filter-nested-item/FilterNestedItem';
import FilterSingleItem from '../filter-single-item/FilterSingleItem';

import { ListStyled } from './FiltersList.style';

const FiltersList = ({
  children,
}: {
  children: JSX.Element | JSX.Element[] | any;
}) => {
  const customChildren = Array.isArray(children) ? children : [children];

  return (
    <ListStyled component="nav" aria-labelledby="">
      {React.Children.toArray(
        customChildren?.map((Child) => {
          return <Child.type {...Child.props} />;
        })
      )}
    </ListStyled>
  );
};

export default FiltersList;

export { FilterSingleItem, FilterNestedItem };
